import React, { useMemo } from 'react';
import { StickyNavigation } from 'ui-toolkit';
import { OrdersContainer } from '../../components/orders/OrdersContainer';
import { UserProfileContainer } from '../../components/userProfile/UserProfileContainer';
import { useQueryStringQuery } from 'pages/useQueryStringQuery';
import { createDefaultSearchOrderSpecification } from '../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';

export const OrdersPage: React.FC = () => {
  const defaultQuery = useMemo(() => createDefaultSearchOrderSpecification(), []);
  const { queryObject, setQueryObject } = useQueryStringQuery('orders', defaultQuery);
  const onReset = () => setQueryObject(defaultQuery);

  return (
    <>
      <StickyNavigation activeMain={'Orders'} profile={<UserProfileContainer />} />
      <OrdersContainer
        searchSettings={queryObject}
        onReset={onReset}
        queryObject={queryObject}
        setQueryObject={setQueryObject}
      />
    </>
  );
};
